module.exports = __webpack_public_path__ + "static/media/doc.9ddb973d.svg";